var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-dropdown-menu',[_c('van-dropdown-item',{ref:"dropdownOrg",attrs:{"title":_vm.activeOrg.org_name}},[_c('org-collapse',{attrs:{"org-data":_vm.orgData},on:{"dropdownToggle":_vm.dropdownToggle}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }